module.exports = __webpack_public_path__ + "static/media/icon-microphone.b8437cf7.svg";